import type { MetaFunction } from 'react-router'
import { useSearchParams } from 'react-router'
import FooterSection from '#app/components/Landing-page/footer-section'
import { BlogCard } from '#app/components/blog/BlogCard'
import { CategoryFilter } from '#app/components/blog/CategoryFilter'
import { FeaturedPost } from '#app/components/blog/FeaturedPost'
import {
	blogPosts,
	categories,
	getBlogPosts,
	getFeaturedPost,
} from '#app/data/blog'

export const meta: MetaFunction = () => {
	const title = 'Blog — TrueTenant'
	const description =
		'Guides, tips, and insights for Canadian tenants and landlords. Learn how to rent smarter, screen better, and navigate the rental market with confidence.'

	return [
		{ title },
		{ name: 'description', content: description },
		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
		{ property: 'og:type', content: 'website' },
		{ name: 'twitter:card', content: 'summary_large_image' },
		{ name: 'twitter:title', content: title },
		{ name: 'twitter:description', content: description },
	]
}

export default function BlogIndexRoute() {
	const [searchParams] = useSearchParams()
	const activeCategory = searchParams.get('category') ?? 'All'
	const featuredPost = getFeaturedPost()
	const allPosts = getBlogPosts(activeCategory)
	const gridPosts = allPosts.filter(
		(p) => !p.featured || activeCategory !== 'All',
	)

	return (
		<div>
			{/* Hero strip */}
			<section className="bg-[#F8F9FA] px-4 py-16 text-center md:px-[100px] md:py-20">
				<p className="mb-3 text-sm font-medium uppercase tracking-widest text-[#747474]">
					TrueTenant Blog
				</p>
				<h1 className="font-['Futura_Hv_BT'] text-[36px] leading-tight text-[#32302F] md:text-[52px]">
					Insights for Smarter Renting
				</h1>
				<p className="mx-auto mt-4 max-w-xl text-[#747474] md:text-lg">
					Practical guides and market insights for Canadian tenants and
					landlords.
				</p>
			</section>

			<div className="px-4 py-12 md:px-[100px]">
				{/* Featured post — only show when viewing All */}
				{activeCategory === 'All' && (
					<div className="mb-14">
						<FeaturedPost post={featuredPost} />
					</div>
				)}

				{/* Category filter */}
				<div className="mb-8">
					<CategoryFilter categories={categories} />
				</div>

				{/* Posts grid */}
				{gridPosts.length > 0 ? (
					<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
						{gridPosts.map((post) => (
							<BlogCard key={post.slug} post={post} />
						))}
					</div>
				) : (
					<div className="py-20 text-center text-[#747474]">
						No posts in this category yet.
					</div>
				)}
			</div>

			<FooterSection />
		</div>
	)
}
